import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { TwilioSendRequestBody, TwilioSendResponse } from "./types";

export class TwilioSendAPI extends BaseAPI<
  TwilioSendRequestBody,
  TwilioSendResponse
> {
  protected route = ApiRoutes.twilio.send;
  protected method = RequestMethod.POST;
}
